function setBadgeCount(badgeCount) {
  if (
    !window.electron ||
    !window.electron.globals ||
    !window.electron.globals.badge ||
    !window.electron.globals.badge.setBadgeCount
  ) {
    return;
  }

  window.electron.globals.badge.setBadgeCount(badgeCount);
}

export default setBadgeCount;
